import React from 'react';
import axios from 'axios';
import Ruta from './Ruta';
import ModalFormulario from './ModalFormulario';
import ModalNoAtiende from './ModalNoAtiende';
import ModalEleccion from './ModalEleccion';
import {Boton} from '../comun/Index';
const google = window.google;

let googleMapa;
let marcadores = [];

const consultaGet = function(url, config) {
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + url, config)
    .then((resul) => {
      if (resul.data.status === "ok"){
        resolve(resul.data);
      } else {
        reject(resul.data.error);
      }
    })
    .catch((error) => {
      reject(error)
    });
  });
}

const consultaPost = function(url, datos, config) {
  return new Promise(function(resolve, reject) {
    axios.post(localStorage.getItem('apiUrl') + url, datos, config)
    .then((resul) => {
      if (resul.data.status === "ok"){
        resolve(resul.data);
      } else {
        reject(resul.data.error);
      }
    })
    .catch((error) => {
      reject(error)
    });
  });
}

const getRuta = function(){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/rutas/agente/buscar';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaGet(url, config)
    .then((data) => resolve(data.ruta))
    .catch((error) => reject(error))
  });
}

const postNoAtiende = function(datos){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/rutas/agente/atencion';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaPost(url, datos, config)
    .then(() => resolve())
    .catch((error) => reject(error))
  });
}

const postDatos = function(datos){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/padron/agente/completar-formulario';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaPost(url, datos, config)
    .then(() => {
      resolve()
    })
    .catch((error) => reject(error))
  });
}

export default class Gestion extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      ruta:[],
      showModalNoAtiende:false,
      showModalFormulario:false,
      showModalEleccion:false,
      asignacion_id:null,
      tipoModal:""
    }
  }

  componentDidMount(){
    this.cargarDatos();
  }

  cargarDatos(){
    getRuta()
    .then((ruta) => {
      this.setState({ruta});
      this.abrirMapa();
    })
    .catch((error) => console.log(error))
  }

  componentWillUnmount(){
    marcadores = []
  }
//-54.806518330177056, -68.30626216769735
  abrirMapa(){
    googleMapa = new google.maps.Map(document.getElementById('mapa'), {
      center: { lat:-54.806518330177056, lng:-68.30626216769735 },
      zoom: 12,
    })
    setTimeout(() => {
      this.cargarMarcadores(this.state.ruta);
    },  1500)
  }

  seleccionarPersona(persona, asignacion_id, soloUbicacion){
    const ubicacion = {
      lat: parseFloat(persona.latitud),
      lng: parseFloat(persona.longitud)
    };
    googleMapa.setCenter(ubicacion);
    googleMapa.setZoom(18);
    if (!soloUbicacion)
      setTimeout(() => {
        this.setState({showModalEleccion:true, asignacion_id})
      },1500)
  }

  clickMarcadorEvento(index, item){
    marcadores[index].informacion.open(googleMapa, marcadores[index].marcador);
    this.seleccionarPersona(item)
  }

  async cargarMarcadores(padron, ruta = false){
    padron.forEach((item, i) => {
      const ubicacion = {
        lat:parseFloat(item.persona.latitud),
        lng:parseFloat(item.persona.longitud)
      }
      const contentString =
        '<div id="content" style="color:black">' +
          '<div id="siteNotice">' +
          "</div>" +
          '<h1 id="firstHeading" class="firstHeading">' + item.persona.documento +  " - " + item.persona.apellidos + ", " + item.persona.nombres + '</h1>' +
          '<div id="bodyContent">' +
            '<h2>Dirección: ' + item.persona.calle + ' ' +  item.persona.numero + '</h2>' +
            '<h3>Estado: ' + item.estado + '</h3>' +
          '</div>' +
        '</div>';
      const cantidad = marcadores.push({
        informacion:new google.maps.InfoWindow({
          content: contentString,
        }),
        marcador:new google.maps.Marker({
          position: ubicacion,
          map: googleMapa,
          opacity:item.estado === "RESUELTO" ? 0.3 : 1,
          optimized:true
        })
      });
      marcadores[cantidad-1].marcador.addListener('click',(e) => this.clickMarcadorEvento(cantidad-1, item))
    });
  }

  atiende(asignacion_id){
    window.scrollTo(0,0);
    this.setState({showModalNoAtiende:true, asignacion_id, tipoModal:"Atiende"})
  }

  noAtiende(asignacion_id){
    window.scrollTo(0,0);
    this.setState({showModalNoAtiende:true, asignacion_id, tipoModal:"No atiende"})
  }

  noAtiendeGuardar(datos){
    const datosNoAtiende = {
      asignacion_id:datos.asignacion_id,
      descripcion:datos.descripcion,
      estado: datos.tipoModal === "Atiende" ? "RESUELTO" : "NO ATIENDE"
    }
    postNoAtiende(datosNoAtiende)
    .then((resul) => {
      alert("Guardado!");
      this.setState({showModalNoAtiende:false, persona_id:null})
      this.cargarDatos();
    })
    .catch((error) => console.log(error))
  }

  atiendeGuardar(datos){
    console.log(datos);
    postDatos({datos})
    .then((resul) => {
      alert("Guardado!");
      this.setState({showModalFormulario:false, persona_id:null});
      this.cargarDatos();
    })
    .catch((error) => console.log(error))
  }

  render(){
    const {ruta, showModalFormulario, showModalNoAtiende,showModalEleccion, asignacion_id,tipoModal} = this.state;
    return(
      <div className="Todo Index">
        {showModalEleccion &&
          <ModalEleccion
            asignacion_id={asignacion_id}
            salir={() => this.setState({showModalEleccion:false, persona_id:null})}
            atiende={() => this.setState({showModalNoAtiende:true, asignacion_id, tipoModal:"Atiende"})}
            noAtiende={() => this.setState({showModalNoAtiende:true, asignacion_id, tipoModal:"No atiende"})}
          />
        }
        {showModalFormulario &&
          <ModalFormulario
            asignacion_id={asignacion_id}
            guardar={(datos) => this.atiendeGuardar(datos)}
            salir={() => this.setState({showModalFormulario:false, persona_id:null})}
          />
        }
        {showModalNoAtiende &&
          <ModalNoAtiende
            tipoModal={tipoModal}
            asignacion_id={asignacion_id}
            guardar={(datos) => this.noAtiendeGuardar(datos)}
            salir={() => this.setState({showModalNoAtiende:false, persona_id:null})}
          />
        }
        <h2>Mis rutas</h2>
        <div style={{width:'100%', display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
          <div style={{flex:2, display:'flex', flexDirection:'column', alignItems:'center', }}>
            <h4 style={{margin:10}}>Ubicaciones</h4>
            <div id="mapa" style={{width:'95%',height: 500, minWidth:200, borderRadius:10, overflow:'hidden'}} ref={this.googleMapa}></div>
          </div>
          <div style={{flex:1, width:'100%', display:'flex', flexDirection:'column', alignItems:'center'}}>
            <h4 style={{margin:10, padding:0}}>Ruta del agente</h4>
            {/*
              <div style={{marginBottom:"10px"}}>
                <Boton
                  backgroundColor="orange"
                  titulo="Formulario nueva persona"
                  onClick={() => this.atiende(0)}
                />
              </div>
            */}
            <Ruta
              ruta={ruta}
              seleccionarPersona={(persona,asignacion_id, soloUbicacion) => this.seleccionarPersona(persona,asignacion_id,soloUbicacion)}
              atiende={(asignacion_id) => this.atiende(asignacion_id)}
              noAtiende={(asignacion_id) => this.noAtiende(asignacion_id)}
            />
          </div>
        </div>
      </div>
    );
  }
}
